export enum TokenResponse {
  Valid = 1,
  Expired = 2,
  NotExist = 3,
}